export default __webpack_public_path__ + "static/media/214.05eda480.jpg";